export default {"src":"/_next/static/media/laptop_basic_icon.b0b31873.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};